// Typography used by the Groups and Happy Hour sites (and redlobster.com/rewards):
// alkaline for script headings and nobel for body copy from Red Lobster's
// Adobe Fonts kit, Antonio for the Happy Hour display headings. Blocks ported
// from those sites render these links so React hoists them into <head> only on
// pages that use them.
export const TYPEKIT_URL = "https://use.typekit.net/fpk4kzc.css";
export const ANTONIO_URL =
    "https://fonts.googleapis.com/css2?family=Antonio:wght@500&display=swap";
